import * as React from 'react'
import { useCallback, useContext } from 'react'
import { useIntl } from 'react-intl'
import styled from 'styled-components'
import { rem } from 'polished'
import Group from 'components/utils/Group'
import BodyText from 'LuxKit/Typography/BodyText'
import TextButton from 'LuxKit/Button/TextButton'
import ModalContext from 'contexts/ModalContext'
import MaldivesReturnForFreeInfoModal from 'components/MaldivesDirect/MaldivesReturnForFreeInfoModal'
import MaldivesReturnForFreeMemberLabel from 'components/MaldivesDirect/MaldivesReturnForFreeMemberLabel'

const BorderedPanel = styled.div`
  background-color: ${props => props.theme.palette.neutral.surface.normalBackground};
  border: 1px solid ${props => props.theme.palette.product.luxPlus.foreground};
  border-radius: ${rem(8)};
  padding: ${rem(16)};
`

interface Props {
  onCheckAvailability: () => void
}

function MaldivesOfferReturnForFreeBanner({ onCheckAvailability }: Props) {
  const intl = useIntl()
  const showModal = useContext(ModalContext)

  const handleInfoClick = useCallback((event: React.MouseEvent<HTMLElement>) => {
    event.preventDefault()
    event.stopPropagation()
    showModal(<MaldivesReturnForFreeInfoModal onCheckAvailability={onCheckAvailability} />)
  }, [onCheckAvailability, showModal])

  return (
    <BorderedPanel data-testid="maldives-offer-return-for-free-banner">
      <Group
        direction="vertical"
        tabletDirection="horizontal"
        gap={12}
        tabletHorizontalAlign="space-between"
        verticalAlign="center"
        horizontalAlign="center"
      >
        <Group
          direction="vertical"
          tabletDirection="horizontal"
          gap={16}
          verticalAlign="center"
          horizontalAlign="center"
          tabletHorizontalAlign="start"
          wrap="wrap"
        >
          <MaldivesReturnForFreeMemberLabel showInfoIcon onInfoClick={handleInfoClick} />
          <BodyText variant="medium" align="center" tabletAlign="start">
            {intl.formatMessage({
              id: '4ozRwBCxc6bsHeleCX74',
              defaultMessage: 'Return flight FREE on select dates and packages for 2027 Maldives bundles. Limited seats available.',
              description: 'Callout above the Maldives charter offer package list telling the customer some dates include a free return flight',
            })}
          </BodyText>
        </Group>

        <TextButton kind="tertiary" size="medium" onClick={onCheckAvailability}>
          {intl.formatMessage({
            id: 'yar5d-zypxU1qJTiEYNF',
            defaultMessage: 'Check availability',
            description: 'Call to action on the Maldives offer page return for free banner that opens the date picker',
          })}
        </TextButton>
      </Group>
    </BorderedPanel>
  )
}

export default MaldivesOfferReturnForFreeBanner
